module.exports = __webpack_public_path__ + "img/lct.85fe2a81.png";